/*******************************************************************************
* Licensed Materials - Property of HCL
* (c) Copyright HCL Technologies Ltd. 2020, 2023. All Rights Reserved.

* Note to U.S. Government Users Restricted Rights:
* Use, duplication or disclosure restricted by GSA ADP Schedule
**************************************************************/

import { Button } from "vr-react-components"

export const createButtonState = (text, type) => {
    const types = Object.keys(Button.constants)

    if (!types.includes(type)) type = Button.constants.primary

    return { text, type }
}